import Vue from 'vue'
import Promise from 'promise'

var METHOD = {
    POST: 'POST',
    GET: 'GET',
    // PUT: 'PUT',
    // DELETE: 'DELETE',
    PATCH: 'PATCH'
}
// const apiUrl = 'http://127.0.0.1:8106'
// const udbUrl = 'http://127.0.0.1:8106'

const apiUrl = 'https://b702934k67.imdo.co'
const udbUrl = 'https://b702934k67.imdo.co'

let storageKey = 'user'
let storage = {
    get(key) {
        let data = localStorage.getItem(key)
        if (data) {
            return JSON.parse(data)
        } else {
            return null
        }
    },
    set(key, value) {
        let data = null
        if (value) {
            data = JSON.stringify(value)
        } else {
            data = null
        }
        localStorage.setItem(key, data)
    },
    remove(key) {
        let data = localStorage.getItem(key)
        if (data) {
            localStorage.removeItem(key)
        }
    }
}

var profile = {
    getApiUrl() {
        return apiUrl
    },
    getProfile() {
        return storage.get(storageKey)
    },
    getUser() {
        let data = storage.get(storageKey)
        if (data && data.user) {
            return data.user
        } else {
            return null
        }
    },
    getUid() {
        let data = storage.get(storageKey)
        if (data && data.user) {
            return data.user.id
        } else {
            return null
        }
    },
    clear() {
        localStorage.clear()
        storage.remove(storageKey)
    },
    setUser(data) {
        storage.set(storageKey, data)
    },
    getHeaders() {
        let headerData = {}
        let userData = storage.get(storageKey)
        if (userData) {
            if (userData.user && userData.user.id) {
                headerData['X-User-Id'] = userData.user.id
            }
            if (userData.token) {
                headerData['Authorization'] = userData.token
            }
        }
        return headerData
    }
}

let createApi = (opts, funcSucc) => {
    let headerData = {}
    if (opts.isStream) {
        // headerData['Content-Type'] = 'multipart/form-data' // 'application/octet-stream'
        headerData['Content-Type'] = 'application/octet-stream'
    } else {
        headerData['Content-Type'] = 'application/json;charset=utf-8'
    }
    let userData = profile.getProfile()
    if (userData) {
        if (userData.user && userData.user.id) {
            headerData['X-User-Id'] = userData.user.id
        }
        if (userData.token) {
            headerData['Authorization'] = userData.token
        }
    }
    var promise = new Promise(function (resolve, reject) {
        let actionUrl = apiUrl + opts.url
        if (opts.url === '/search/udbQuery' || opts.url === '/search/InfoDetail' || opts.url === '/search/rawQuery' || opts.url === '/search/download_txt') {
            actionUrl = udbUrl + opts.url
        }
        Vue.http({
            method: opts.method || 'GET',
            url: actionUrl,
            params: opts.params || {},
            body: opts.data || {},
            headers: headerData,
            cache: false,
            timeout: 30000
        }).then(function (response) {
            if (response.body != null && response.body.message == '请重新登录系统') {
                localStorage.clear()
            }
            if (response.data != null) {
                resolve(response.data)
            } else {
                resolve(response)
            }
            // console.log(response)
            // if (resp.code >= 400) {
            //     reject(resp)
            // } else {
            //     resolve(resp)
            // }
        }, function (response) {
            let status = response.status
            if (status === 401) {
                // profile.clear()
                response.data.type = 'error'
                reject(response.data)
            } else if (status === 403) {
                // console.log(response)
                let resp = {
                    type: 'error',
                    code: status,
                    title: '访问拒绝',
                    message: '请登录系统'
                }
                reject(resp)
                window.location = '/#/login'
            } else if (status === 420) {
                let resp = {
                    type: 'error',
                    code: status,
                    title: '访问拒绝',
                    message: 'token 无效,请重新登录'
                }
                reject(resp)
            } else if (status === 421) {
                let resp = {
                    type: 'error',
                    code: status,
                    title: '访问拒绝',
                    message: 'token 过期,请重新登录'
                }
                profile.clear()
                reject(resp)
            } else if (status === 500) {
                // 500 验证码为空、过期、错误
                let resp = {
                    type: 'error',
                    code: status,
                    title: '验证失败',
                    message: response.bodyText
                }
                reject(resp)
            } else if (status === 510) {
                // 登录错误，用户不存在，密码错误，过期，禁用。。。
                let resp = {
                    type: 'error',
                    code: status,
                    title: '登录失败',
                    message: response.bodyText
                }
                reject(resp)
            } else if (status === 511) {
                // 登录错误，用户不存在，密码错误，过期，禁用。。。
                let resp = {
                    type: 'error',
                    code: status,
                    title: '用户不存在',
                    message: response.bodyText
                }
                reject(resp)
            } else if (status === 512) {
                // 登录错误，用户不存在，密码错误，过期，禁用。。。
                let resp = {
                    type: 'error',
                    code: status,
                    title: '用户已停用',
                    message: response.bodyText
                }
                reject(resp)
            } else if (status === 513) {
                // 登录错误，用户不存在，密码错误，过期，禁用。。。
                let resp = {
                    type: 'error',
                    code: status,
                    title: '密码错误',
                    message: response.bodyText
                }
                reject(resp)
            } else if (status === 404) {
                let resp = {
                    type: 'error',
                    code: status,
                    title: '接口不存在',
                    message: '404错误，没有找到请求地址，请联系管理员'
                }
                reject(resp)
            } else if (status === 0) {
                let resp = {
                    type: 'error',
                    code: status,
                    title: '服务器端没有响应',
                    message: '服务器端没有响应，请稍后重试'
                }
                reject(resp)
            } else {
                reject(response.data)
            }
        })
    })
    return promise
}

let handError = {
    action(context, res) {
        console.log("error!")
        context.$message({
            title: res.title,
            message: res.message,
            type: res.status
        })
    }
}

let user = {
    login(data) {
        profile.clear()
        return createApi({
            url: '/session',
            method: METHOD.POST,
            data: data
        })
    },
    getMenus(data) {
        return createApi({
            url: '/menu/getMenus',
            method: METHOD.POST,
            data: data
        })
    }
}

let admin = {
    adminList(index, size) {
        return createApi({
            url: '/user/adminList',
            method: METHOD.POST,
            data: {
                index,
                size
            }
        })
    },
    userList(index, size, key, value) {
        return createApi({
            url: '/user/list',
            method: METHOD.POST,
            data: {
                index,
                size,
                key,
                value
            }
        })
    },
    get_user_by_name(name) {
        return createApi({
            url: '/user/getUserByName',
            method: METHOD.POST,
            data: name
        })
    },
    update_user_role(data) {
        return createApi({
            url: '/user/update_user_role',
            method: METHOD.POST,
            data: data
        })
    },
    enabledUser(data) {
        return createApi({
            url: '/user/enabledUser',
            method: METHOD.POST,
            data: data
        })
    },
    resetPwd(data) {
        return createApi({
            url: '/user/resetPwd',
            method: METHOD.POST,
            data: data
        })
    },
    addUser(data) {
        return createApi({
            url: '/user/add',
            method: METHOD.POST,
            data: data
        })
    },
    updateUserInfo(data) {
        return createApi({
            url: '/user/updateInfo',
            method: METHOD.POST,
            data: data
        })
    },
    updateUser(data) {
        return createApi({
            url: '/user/updateUser',
            method: METHOD.POST,
            data: data
        })
    },
    delAdmin(data) {
        return createApi({
            url: '/user/delAdmin',
            method: METHOD.POST,
            data: data
        })
    },
    updatePassword(data) {
        return createApi({
            url: '/user/updatePassword',
            method: METHOD.POST,
            data: data
        })
    },
    roleList(index, size) {
        return createApi({
            url: '/role/list',
            method: METHOD.POST,
            data: {
                index,
                size
            }
        })
    },
    roleAdd(data) {
        return createApi({
            url: '/role/add',
            method: METHOD.POST,
            data: data
        })
    },
    updateRole(data) {
        return createApi({
            url: '/role/update',
            method: METHOD.POST,
            data: data
        })
    },
    delRole(data) {
        return createApi({
            url: '/role/delete',
            method: METHOD.POST,
            data: data
        })
    },
    inputList(index, size, sortfield, direction) {
        return createApi({
            url: '/log/inputList',
            method: METHOD.POST,
            data: {
                index: index,
                size: size,
                sortfield: sortfield,
                direction: direction
            }
        })
    },
    deleteDocs(data) {
        return createApi({
            url: '/api/v1/delDocs',
            method: METHOD.POST,
            data: data
        })
    },
    executeOrder(data) {
        return createApi({
            url: '/api/v1/execute',
            method: METHOD.POST,
            data: data
        })
    },
    getAlertMsg() {
        return createApi({
            url: '/api/v1/getAlertMsg',
            method: METHOD.POST
        })
    },
    updateAlertMsg(data) {
        return createApi({
            url: '/api/v1/updateAlertMsg',
            method: METHOD.POST,
            data: data
        })
    },
    groupList(index, size) {
        return createApi({
            url: '/group/list',
            method: METHOD.POST,
            data: {
                index,
                size
            }
        })
    },
    deparAdd(data) {
        return createApi({
            url: '/dep/add',
            method: METHOD.POST,
            data: data
        })
    },
    getUserByDepartmentId(data) {
        return createApi({
            url: '/user/getUserByDepartment',
            method: METHOD.POST,
            data: data
        })
    },
    groupAdd(data) {
        return createApi({
            url: '/group/add',
            method: METHOD.POST,
            data: data
        })
    },
    groupRemove(data) {
        return createApi({
            url: '/group/delete',
            method: METHOD.POST,
            data: data
        })
    },
    enabledGroup(data) {
        return createApi({
            url: '/group/enable',
            method: METHOD.POST,
            data: data
        })
    }
}


let slice = {
    getInfoDetail(_id, _index, _type) {
        return createApi({
            url: '/search/InfoDetail',
            method: METHOD.POST,
            data: {
                _id,
                _index,
                _type
            }
        })
    },
    getFileList(index, size) {
        return createApi({
            url: '/model/filelist',
            method: METHOD.POST,
            data: {
                index,
                size
            }
        })
    },
    getFapiaoList(index, size) {
        return createApi({
            url: '/fapiao/list',
            method: METHOD.POST,
            data: {
                index,
                size
            }
        })
    },
    addFapiao(data) {
        return createApi({
            url: '/fapiao/add',
            method: METHOD.POST,
            data: data
        })
    },
    delFapiao(data) {
        return createApi({
            url: '/fapiao/delete',
            method: METHOD.POST,
            data: data
        })
    },
    getScheduleList(index, size) {
        return createApi({
            url: '/schedule/list',
            method: METHOD.POST,
            data: {
                index,
                size
            }
        })
    },
    addSchedule(data) {
        return createApi({
            url: '/schedule/add',
            method: METHOD.POST,
            data: data
        })
    },
    delSchedule(data) {
        return createApi({
            url: '/schedule/delete',
            method: METHOD.POST,
            data: data
        })
    },
    getContractByCus(customerId, index, size) {
        return createApi({
            url: '/contract/getlistByCus',
            method: METHOD.POST,
            data: {
                customerId,
                index,
                size
            }
        })
    },
    getContractList(index, size) {
        return createApi({
            url: '/contract/list',
            method: METHOD.POST,
            data: {
                index,
                size
            }
        })
    },
    addContract(data) {
        return createApi({
            url: '/contract/add',
            method: METHOD.POST,
            data: data
        })
    },
    delContract(data) {
        return createApi({
            url: '/contract/delete',
            method: METHOD.POST,
            data: data
        })
    },
    getCustomerList(index, size) {
        return createApi({
            url: '/customer/list',
            method: METHOD.POST,
            data: {
                index,
                size
            }
        })
    },

    delCustomer(data) {
        return createApi({
            url: '/customer/delete',
            method: METHOD.POST,
            data: data
        })
    },
    listContacts(index, size) {
        return createApi({
            url: '/cont/list',
            method: METHOD.POST,
            data: {
                index,
                size
            }
        })
    },
    getCandiByTask(taskId, index, size) {
        return createApi({
            url: '/candi/getCandiByTask',
            method: METHOD.POST,
            data: {
                taskId,
                index,
                size
            }
        })
    },

    addUdbToContacts(data, task_id) {
        return createApi({
            url: '/cont/addUdbToContacts',
            method: METHOD.POST,
            data: {
                idList: data,
                taskId: task_id
            }
        })
    },
    getTaskList(index, size, userId) {
        return createApi({
            url: '/task/list',
            method: METHOD.POST,
            data: {
                index,
                size,
                userId
            }
        })
    },
    addTask(data) {
        return createApi({
            url: '/task/add',
            method: METHOD.POST,
            data: data
        })
    },
    delTask(data) {
        return createApi({
            url: '/task/delete',
            method: METHOD.POST,
            data: data
        })
    },
    getFileInputById(data) {
        return createApi({
            url: '/model/getFileInputById',
            method: METHOD.POST,
            data: data
        })
    },
    nerQuery(data) {
        return createApi({
            url: '/search/nerQuery',
            method: METHOD.POST,
            data: data
        })
    },
    entQuery(data) {
        return createApi({
            url: '/slice/entQuery',
            method: METHOD.POST,
            data: data
        })
    },
    empQuery(data) {
        return createApi({
            url: '/search/empQuery',
            method: METHOD.POST,
            data: data
        })
    },
    stockQuery(data) {
        return createApi({
            url: '/search/stockQuery',
            method: METHOD.POST,
            data: data
        })
    },
    baikeQuery(data) {
        return createApi({
            url: '/search/baikeQuery',
            method: METHOD.POST,
            data: data
        })
    },
    rsmQuery(data) {
        return createApi({
            url: '/search/rsmQuery',
            method: METHOD.POST,
            data: data
        })
    },
    wenQuery(data) {
        return createApi({
            url: '/search/wenQuery',
            method: METHOD.POST,
            data: data
        })
    },
    epsQuery(data) {
        return createApi({
            url: '/search/epsQuery',
            method: METHOD.POST,
            data: data
        })
    }
}

let remote = {
    doPost(data, api_url) {
        return createApi({
            url: api_url,
            method: METHOD.POST,
            data: data
        })
    },
    doGet(api_url) {
        return createApi({
            url: api_url,
            method: METHOD.GET,
        })
    },
    doDownload(data, api_url) {
        return createApi({
            url: api_url,
            method: METHOD.POST,
            data: data,
            isStream: true
        })
    }
}

let setting = {
    getApiUrl() {
        return apiUrl;
    },
}

export default {
    storage,
    profile,
    handError,
    user,
    admin,
    slice,
    remote,
    setting
}



// WEBPACK FOOTER //
// ./src/api/rest.js